import { ReferProps } from '../../interfaces/interfaces';

import './styles.scss';

export function Reference({ id, sales }: ReferProps) {
  return (
    <div className="itens-container-reference">
      <div className="author-wrapper-reference">
        <div className="user-info-reference">
          <span className="title-name">
            {id}
          </span>
          <span className="title-sold">
            {sales} {sales > 1 ? 'PARES' : 'PAR'}
          </span>
        </div>
      </div>
    </div>
  );
}